<div class="main-content mat-dialog-container-dialog">
  <div class="container-fluid container-fluid-dialog">
    <div class="card card-inside card-inside-dialog">
      <div class="card-header card-header-primary">
        <div class="row">
          <div class="col mt5">
            <h4 class="card-title" style="text-align: center;"> Lütfen Bekleyiniz ... </h4>
          </div>
        </div>
      </div>

      <div class="sweet-alert" [hidden]="!loading"
        style="min-height:150px; display: flex; justify-content: center; align-items: center;">
        <mat-spinner strokeWidth="5" diameter="80">
        </mat-spinner>
      </div>

      <div class="sweet-alert" [hidden]="loading"
        style="min-height:150px; display: flex; justify-content: center; align-items: center;">
        <div class="icon success animate">
          <span class="line tip animateSuccessTip"></span>
          <span class="line long animateSuccessLong"></span>
          <span class="placeholder"></span>
          <span class="fix"></span>
        </div>
      </div>

    </div>
  </div>
</div>
